import { render, staticRenderFns } from "./topbar-unread-messages.vue?vue&type=template&id=1c4f4141&scoped=true"
import script from "./topbar-unread-messages.vue?vue&type=script&lang=js"
export * from "./topbar-unread-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f4141",
  null
  
)

export default component.exports